
export const MODULE_NAME = 'users-participants'
